export default __webpack_public_path__ + "static/media/stats-preview-card.2739194f.png";